{
  "admin-hub.adminhub-performance-monitoring-first-run.body-0": [
    {
      "type": 0,
      "value": "See how your apps loaded for users in the last 24 hours, grouped by fast, moderate, and slow experiences."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-1": [
    {
      "type": 0,
      "value": "Understand which configuration issues affect load times, and where improvements can make the difference."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-10": [
    {
      "type": 0,
      "value": "Click any row to see what's impacting this app's performance and review detailed metrics."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-2": [
    {
      "type": 0,
      "value": "Find what's affecting performance the most. View insight details to understand the issue and take the next step."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-3": [
    {
      "type": 0,
      "value": "Explore how load times split across fast, moderate, and slow for the period you chose."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-4": [
    {
      "type": 0,
      "value": "The same data plotted over time, so you can identify when slow loads occurred and tell whether a change helped."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-5": [
    {
      "type": 0,
      "value": "Change the time range and how often data is sampled, or switch between alternative data views."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-6": [
    {
      "type": 0,
      "value": "Compare the impact of network speed, CPU cores, network protocol, and operating system over the last 4 weeks."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-7": [
    {
      "type": 0,
      "value": "Filter to the product or site you care about, then explore the details to learn how page loads are distributed."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-8": [
    {
      "type": 0,
      "value": "Compare load times for each app to quickly assess individual performance and evaluate optimization needs."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.body-9": [
    {
      "type": 0,
      "value": "Use search, filter and sorting capabilities to quickly identify which apps need attention."
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.button-back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.button-done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.button-next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-0": [
    {
      "type": 0,
      "value": "App performance at a glance"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-1": [
    {
      "type": 0,
      "value": "Find what's slowing things down"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-10": [
    {
      "type": 0,
      "value": "View performance breakdown"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-2": [
    {
      "type": 0,
      "value": "Review insights"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-3": [
    {
      "type": 0,
      "value": "See the spread of load times"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-4": [
    {
      "type": 0,
      "value": "Watch load times change"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-5": [
    {
      "type": 0,
      "value": "Adjust the view to get a clear picture"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-6": [
    {
      "type": 0,
      "value": "See how user setup affects load times"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-7": [
    {
      "type": 0,
      "value": "Narrow it to one product or site"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-8": [
    {
      "type": 0,
      "value": "Get a comprehensive overview"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.heading-9": [
    {
      "type": 0,
      "value": "Boost your investigation"
    }
  ],
  "admin-hub.adminhub-performance-monitoring-first-run.step-count": [
    {
      "type": 1,
      "value": "step"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.action.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.action.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.action.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step-counter": [
    {
      "type": 1,
      "value": "current"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step1.body": [
    {
      "type": 0,
      "value": "View active incidents, maintenance events and their details."
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step1.heading": [
    {
      "type": 0,
      "value": "Track current events"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step2.body": [
    {
      "type": 0,
      "value": "Search and filter past incidents and maintenance events."
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step2.heading": [
    {
      "type": 0,
      "value": "Browse event history"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step3.body": [
    {
      "type": 0,
      "value": "View which app experiences across app instances are currently impacted."
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step3.heading": [
    {
      "type": 0,
      "value": "Check experience status"
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step4.body": [
    {
      "type": 0,
      "value": "Get an overview of how events affect your apps and their experiences."
    }
  ],
  "aviator.service-health-dashboard.app-status-spotlight.step4.heading": [
    {
      "type": 0,
      "value": "Review impact on apps"
    }
  ],
  "aviator.service-health-dashboard.spotlight.action.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "aviator.service-health-dashboard.spotlight.action.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "aviator.service-health-dashboard.spotlight.action.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "aviator.service-health-dashboard.spotlight.step-counter": [
    {
      "type": 1,
      "value": "current"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "aviator.service-health-dashboard.spotlight.step1.body": [
    {
      "type": 0,
      "value": "View the current status and recent events for each app in your organization."
    }
  ],
  "aviator.service-health-dashboard.spotlight.step1.heading": [
    {
      "type": 0,
      "value": "Dive into app status"
    }
  ],
  "aviator.service-health-dashboard.spotlight.step2.body": [
    {
      "type": 0,
      "value": "Stay informed about incidents and maintenance events in your organization"
    }
  ],
  "aviator.service-health-dashboard.spotlight.step2.heading": [
    {
      "type": 0,
      "value": "Subscribe to updates"
    }
  ],
  "catapult.adminhub-shd-arb-email-webhook-spotlight-tour.screen-space-flags.description.no-translate": [
    {
      "type": 0,
      "value": "Replace this with a short summary of what this message tells the recipient."
    }
  ],
  "catapult.adminhub-shd-arb-email-webhook-spotlight-tour.screen-space-flags.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ],
  "catapult.adminhub-shd-new-notifications-spotlight.screen-space-flags.description.no-translate": [
    {
      "type": 0,
      "value": "Replace this with a short summary of what this message tells the recipient."
    }
  ],
  "catapult.adminhub-shd-new-notifications-spotlight.screen-space-flags.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ],
  "catapult.adminhub-system-health-dashboard-app-status-spotlight.screen-space-flags.description.no-translate": [
    {
      "type": 0,
      "value": "Replace this with a short summary of what this message tells the recipient."
    }
  ],
  "catapult.adminhub-system-health-dashboard-app-status-spotlight.screen-space-flags.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ]
}